/** Fallback album data for the carousel when the API is unavailable */
export const FANS_COVERS_FALLBACK = [
  {
    image: "/images/featured/cover-1.png",
    title: "Sapphire & Lands",
    artist: "Various Artists",
  },
  { image: "/images/featured/cover-2.png", title: "Breath", artist: "Malia" },
  {
    image: "/images/featured/cover-3.png",
    title: "Midnight Moon",
    artist: "Night Owl",
  },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
  { image: null, title: "Album Name", artist: "Artist Name" },
] as const;

export const FANS_ARTIST_AVATAR_URLS = Array.from(
  { length: 15 },
  (_, i) => `/images/featured/artist-${i + 1}.jpg`,
);
